import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';

import '../../ComplianceRule.css';

class RestrictedSectorGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.restrictedSectorGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        sortable: true,
        filter: true,
        resizable: true,
        // minWidth: 30
      },
      rowSelection: "multiple",
    };
  }

  onSelectionChanged = (event) => {
    var rowNodeArray = event.api.getSelectedNodes();
    var sectorCodeList = rowNodeArray.map(rowNode => rowNode.data);

    this.props.selectRestrictedSectors(sectorCodeList);
  }

  getRowNodeId = data => {
    return data.id;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    // const COLUMNS_KEY = 'fund-list-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      filterRestrictedSectorArray,
      className = 'grid-wrapper',
      isLoaded = false,
    } = this.props;

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoaded ? (
          <Loader active content="Loading..." />
        ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={filterRestrictedSectorArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            animateRows={true}
            immutableData={false}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default RestrictedSectorGrid;